/* @flow */

import type { JSONAPIPayload } from 'common/jsonApi/types';
import { object, record } from 'common/json/extract';
import normalizeJsonApiResources from 'utils/normalizeJsonApiResources';

import type { ExtractValues } from 'common/json/extract/object/record';

export default function normalizedPayload<Resources: {}>(
  resources: Resources
): JSONAPIPayload => ExtractValues<Resources> {
  const extractResourceRecordObject = object(record(resources));
  return jsonApiPayload => {
    const normalizedJsonApiPayload = normalizeJsonApiResources(jsonApiPayload);
    return extractResourceRecordObject(normalizedJsonApiPayload);
  };
}
